<template>
  <v-footer app
    height="auto"
    color="grey darken-3"
  >
    <v-layout justify-center row wrap>
      <v-flex text-xs-center white--text xs12>
        &copy;2019 <strong>Maroondah Cycle Training Club Inc.</strong> Incorporation Registered No. A0001470C
      </v-flex>
    </v-layout>
  </v-footer>
</template>
<script>
export default {
  name: 'adminFooter',
  data: () => ({
    links: [
      {
        name: 'Home',
        path: '/'
      },
      {
        name: 'About Us',
        path: '/#about'
      },
      {
        name: 'FAQ',
        path: '/faq'
      },
      {
        name: 'Services',
        path: '/#services'
      },
      {
        name: 'News',
        path: '/news'
      },
      {
        name: 'Contact Us',
        path: '/#contact'
      }
    ]
  }),
  methods: {
    goto: function (link) {
      this.$router.push(link)
    }
  }
}
</script>
